import React, { Component } from 'react';
import axios from 'axios';
import { uniqBy } from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';

import { CircularProgress, DialogContent } from '@material-ui/core';

class CompetitorModal extends Component {
	state = { competitorData: [], loading: true, error: false };

	async componentDidMount() {
		const { _enterpriseLocation } = this.props;
		const res = await axios.post('/api/local-competitors', {
			_enterpriseLocation
		});

		const { competitorData, error } = res.data;

		if (competitorData || error) {
			this.setState({
				competitorData,
				loading: false,
				error
			});
		}
	}

	async componentWillReceiveProps(nextProps) {
		const { _enterpriseLocation } = nextProps;

		if (this.props._enterpriseLocation !== _enterpriseLocation) {
			this.setState({ loading: true });
		}

		const res = await axios.post('/api/local-competitors', {
			_enterpriseLocation
		});

		const { competitorData, error } = res.data;

		if (competitorData || error) {
			this.setState({
				competitorData,
				loading: false,
				error
			});
		}
	}

	sortMe = (a, b) => {
		const asol = Number(a);
		const bsol = Number(b);
		const order = asol === bsol ? 0 : bsol < asol ? -1 : 1;
		return order;
	};

	renderTableBody = () => {
		const { competitorData } = this.state;

		if (competitorData.length) {
			return uniqBy(competitorData, 'address')
				.sort((a, b) => {
					switch (this.state.sortBy) {
						case 'rating':
							return this.sortMe(a.rating, b.rating);
						case 'reviews':
							return this.sortMe(a.reviews, b.reviews);
						default:
							return this.sortMe(a.reviews, b.reviews);
					}
				})
				.map((competitor, index) => {
					const {
						name,
						rating,
						reviews,
						placeId,
						address
					} = competitor;

					return (
						<TableRow key={placeId || index}>
							<TableCell align="right">{index + 1}</TableCell>
							<TableCell align="right">{name}</TableCell>
							<TableCell align="right">{address}</TableCell>
							<TableCell align="right">{rating}</TableCell>
							<TableCell align="right">{reviews}</TableCell>
						</TableRow>
					);
				});
		}

		return null;
	};

	renderCompetitorTable = () => {
		console.log(this.state);
		if (this.state.error) {
			return <div>No competitors found.</div>;
		}
		return (
			<Table selectable={false}>
				<TableHead>
					<TableRow>
						<TableCell>Rank</TableCell>
						<TableCell align="right">Name</TableCell>
						<TableCell align="right">Address</TableCell>
						<TableCell align="right">
							<Button
								style={{ paddingLeft: 0 }}
								label="Rating"
								onClick={() =>
									this.setState({ sortBy: 'rating' })
								}
								variant="text"
							>
								Rating
							</Button>
						</TableCell>
						<TableCell align="right">
							<Button
								style={{ paddingLeft: 0 }}
								label="Reviews"
								variant="text"
								onClick={() =>
									this.setState({ sortBy: 'reviews' })
								}
							>
								Reviews
							</Button>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody displayRowCheckbox={false}>
					{this.renderTableBody()}
				</TableBody>
			</Table>
		);
	};

	renderLoading = () => {
		return (
			<div className="row">
				<div className="col s12">
					<CircularProgress
						style={{ margin: 241 }}
						color="secondary"
					/>
				</div>
			</div>
		);
	};

	render = () => {
		const { onClose } = this.props;

		return (
			<Dialog
				onClose={onClose}
				aria-labelledby="competitor-dialog-slide-title"
				aria-describedby="competitor-dialog-slide-description"
				fullWidth
				maxWidth={false}
				open={this.props.open}
			>
				<DialogTitle id="simple-dialog-title">
					Local Competitor Reviews
				</DialogTitle>
				<DialogContent>
					<div
						className="row"
						style={{ marginBottom: 10, width: '100%' }}
					>
						{this.state.loading
							? this.renderLoading()
							: this.renderCompetitorTable()}
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose} color="primary" className="">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	};
}

export default CompetitorModal;



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/Modal/CompetitorModal/index.js